import {forwardRef} from 'react'
import ModalTemplate from '../../ui-kit/components/templates/ModalTemplate'
import TabTemplate from '../../ui-kit/components/templates/TabTemplate'
import TabsWrapper from '../../ui-kit/components/wrappers/TabsWrapper'
import PanelTemplate from '../../ui-kit/components/templates/PanelTemplate'
import {reactionsArray} from '../../helpers/data/reactions-data'
import ReactionItemTemplate from '../templates/ReactionItemTemplate'
import uniqid from 'uniqid'
import UserReaction from '../atoms/users/UserReaction'

const ReactionsModal = forwardRef((props, ref) => {
  return (
    <ModalTemplate className="reactions-modal" ref={ref}>
      <TabsWrapper>
        <p className="title title-base">Reacciones</p>
        <header className="reactions-header">
          <TabTemplate index={0}>Todas</TabTemplate>
          {reactionsArray.map((reaction, index) => (
            <TabTemplate key={uniqid()} index={index + 1}>
              <ReactionItemTemplate size="small" type={reaction} />
            </TabTemplate>
          ))}
        </header>
        <PanelTemplate index={0}>
          <UserReaction reaction="LIKE" />
          <UserReaction reaction="LIKE" />
          <UserReaction reaction="LOVE" />
          <UserReaction reaction="EXCELLENT" />
          <UserReaction reaction="PROUD" />
        </PanelTemplate>
        <PanelTemplate index={1}>
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
        </PanelTemplate>
        <PanelTemplate index={2}>
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
        </PanelTemplate>
        <PanelTemplate index={3}>
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
        </PanelTemplate>
        <PanelTemplate index={4}>
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
        </PanelTemplate>
        <PanelTemplate index={5}>
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
          <UserReaction />
        </PanelTemplate>
      </TabsWrapper>
    </ModalTemplate>
  )
})

export default ReactionsModal
